import { Reveal } from "../components/Reveal";
import { MessageCircle, ClipboardList, Rocket, ShieldCheck, Repeat } from "lucide-react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

const STEPS = [
  { icon: MessageCircle, title: "Discovery", body: "A no-cost consultation to understand your business, entity structure and objectives." },
  { icon: ClipboardList, title: "Roadmap", body: "You receive a written compliance roadmap with timelines, fees and clear ownership." },
  { icon: Rocket, title: "Execution", body: "Our specialists file, register, draft or represent — always with a dedicated engagement manager." },
  { icon: ShieldCheck, title: "Certification", body: "Every deliverable is quality-checked and delivered with proof of filing / statutory documentation." },
  { icon: Repeat, title: "Ongoing Compliance", body: "Enrol in our Annual Compliance Programme — never miss a filing, licence or renewal again." },
];

export default function Process() {
  return (
    <div className="pt-36 pb-8" data-testid="process-page">
      <Seo path="/process" title={PAGE_SEO["/process"].title} description={PAGE_SEO["/process"].description} />
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="kb-label mb-6">How We Work</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] max-w-4xl">
            A process built for <span className="italic text-[#d4a840]">clarity.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-lg text-white/70 max-w-3xl leading-relaxed">
            Every engagement follows five predictable steps — so you always know what's next,
            who's accountable and when to expect it.
          </p>
        </Reveal>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 mt-20 relative">
        <div className="absolute left-8 md:left-12 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#d4a840]/50 to-transparent" />
        <div className="space-y-12">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.06}>
                <div className="relative pl-20 md:pl-28" data-testid={`process-step-${i}`}>
                  <div className="absolute left-0 top-0 w-16 md:w-24 flex items-center justify-center">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-[#050A15] border border-[#d4a840]/40 flex items-center justify-center relative z-10 shadow-[0_0_30px_rgba(212,168,64,0.15)]">
                      <Icon size={22} className="text-[#d4a840]" />
                    </div>
                  </div>
                  <div className="kb-glass rounded-2xl p-7 md:p-9">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="font-display text-4xl md:text-5xl font-bold text-[#d4a840]/50">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <h2 className="font-display text-2xl md:text-3xl font-semibold text-white">{s.title}</h2>
                    </div>
                    <p className="text-white/70 leading-relaxed max-w-2xl">{s.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 mt-32 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white leading-tight">
            Start with a <span className="italic text-[#d4a840]">free consultation.</span>
          </h2>
          <div className="mt-8">
            <Link to="/contact" className="kb-btn-primary" data-testid="process-cta">Book a discovery call</Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
